{
    "required": "Detta fält är obligatoriskt.",
    "range": "Talet måste vara mellan {min} och {max}, var {actual}.",
    "digits": "Ange endast siffror."
}
